import { render, staticRenderFns } from "./TextUploadDialog.vue?vue&type=template&id=841c2a80&scoped=true&"
import script from "./TextUploadDialog.vue?vue&type=script&lang=js&"
export * from "./TextUploadDialog.vue?vue&type=script&lang=js&"
import style0 from "./TextUploadDialog.vue?vue&type=style&index=0&id=841c2a80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841c2a80",
  null
  
)

export default component.exports